import React, { useState } from 'react';

import { apiService } from '../../components/Config/api.service';

const COLONNES_ATTENDUES = 'matricule, salaire_brut, salaire_net, mois_annee, et facultativement heures_sup et primes';

const PayrollImport = () => {
    const [fichier, setFichier] = useState(null);
    const [enCours, setEnCours] = useState(false);
    const [rapport, setRapport] = useState(null);
    const [erreur, setErreur] = useState(null);

    const handleFichier = (event) => {
        setFichier(event.target.files?.[0] || null);
        setRapport(null);
        setErreur(null);
    };

    const handleImport = async () => {
        if (!fichier || enCours) {
            return;
        }

        setEnCours(true);
        setRapport(null);
        setErreur(null);

        try {
            const resultat = await apiService.importPayrollCsv(fichier);
            setRapport(resultat);
        } catch (error) {
            setErreur(error?.userMessage || "L'import n'a pas abouti.");
        } finally {
            setEnCours(false);
        }
    };

    const rejets = rapport?.rejected || [];
    const refuse = rapport && !rapport.ok;

    return (
        <div className="p-4">
            <h1 className="text-2xl font-semibold mb-2">Import de paie</h1>
            <p className="mb-6 text-sm opacity-80">
                Déposez le fichier CSV des éléments de paie du mois. Colonnes attendues : {COLONNES_ATTENDUES}.
                Le fichier est vérifié avant écriture : s'il contient une seule erreur, rien n'est importé.
            </p>

            <div className="flex flex-wrap items-end gap-4 mb-6">
                <div className="flex flex-col gap-1">
                    <label htmlFor="payroll-import-file" className="text-sm font-medium">
                        Fichier CSV
                    </label>
                    <input
                        id="payroll-import-file"
                        type="file"
                        accept=".csv,text/csv"
                        onChange={handleFichier}
                        className="file-input file-input-bordered"
                    />
                </div>

                <button
                    type="button"
                    onClick={handleImport}
                    disabled={!fichier || enCours}
                    className="btn btn-primary"
                >
                    {enCours ? 'Import en cours…' : 'Importer'}
                </button>
            </div>

            {erreur && (
                <div role="alert" className="alert alert-error mb-4">
                    {erreur}
                </div>
            )}

            {rapport?.ok && (
                <div role="status" className="alert alert-success mb-4">
                    Import terminé : {rapport.created} ligne(s) créée(s), {rapport.updated} ligne(s) mise(s) à jour.
                </div>
            )}

            {refuse && (
                <div role="alert" className="mb-4">
                    <p className="mb-3 font-medium">
                        Import refusé : aucune ligne n'a été enregistrée. Corrigez le fichier puis réessayez.
                    </p>
                    <table className="table w-full">
                        <thead>
                            <tr>
                                <th scope="col">Ligne</th>
                                <th scope="col">Motif</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rejets.map((rejet, index) => (
                                <tr key={`${rejet.line}-${index}`}>
                                    <td>{rejet.line}</td>
                                    {/* Motif affiché tel quel : il vient d'Odoo, qui seul connaît
                                        la règle violée. On ne le reformule ni ne l'interprète. */}
                                    <td>{rejet.reason}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default PayrollImport;
